function getContext() {
  const pages = getCurrentPages();
  return pages[pages.length - 1];
}

function setComponent(ref, props = {}) {
  let instance;
  // #ifdef H5
  instance = getContext().$refs?.globalComponent;
  // #endif
  // #ifndef H5
  instance = getContext().$vm?.$refs?.globalComponent;
  // #endif
  return instance?.setComponent(ref, props);
}

export {
  setComponent,
};
